import axios from "axios";
import { levelsMap } from "utility/levelsData";
import { GAME_TIME } from "utility/Timer";
import { storage } from "./config/storage";
import * as Sentry from "@sentry/react";
import { GC } from "./config/gamecentreService";

const logError = (error) => {
  if(error?.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Sentry.setExtra("response", error.response)
      Sentry.captureException(error)
  } else if(error?.request) {
      // The request was made but no response was received
      Sentry.setExtra("request", error.request)
      Sentry.captureException(error)
  } else {
      // Something happened in setting up the request that triggered an Error
      Sentry.captureException(error?.message)
  }
}

const sum = (list, sliceLength, initialSum = 0, property = null) => {
  return list
    .slice(0, sliceLength)
    .reduce(
      (prev, current) => (property ? prev + current[property] : prev + current),
      initialSum
    );
};

const transform = ({
  currentLevel,
  time,
  moves,
  playMoves,
  pastMoves,
  seconds,
  completed
}) => {
  let index = currentLevel - 1,
    levels = levelsMap.slice(0, currentLevel),
    optimal = levels.map(level => level.metadata.optimalSolution),
    movesObject = moves
      .slice(0, currentLevel)
      .map(move =>
        move.movesArray
          .map(entry => (entry === "PROCEDURE" ? move.loopArray.length : 1))
          .reduce((prev, current) => prev + current, 0)
      ),
    pastMovesObject = pastMoves.slice(0, currentLevel).map(pastMoveList =>
      pastMoveList.reduce(
        (prev, current) => ({
          main: prev.main + current.main,
          proc: prev.proc + current.proc,
          total: prev.total + current.total
        }),
        { main: 0, proc: 0, total: 0 }
      )
    ),
    timeObject = time.slice(0, currentLevel).map(time => time.start - time.end),
    commandList = moves.slice(0, currentLevel).map(move => ({
      main: move.movesArray.length,
      proc: move.loopArray.length
    })),
    totalMoves =
      sum(movesObject, currentLevel) +
      sum(pastMovesObject, currentLevel, 0, "total"),
    totalTime = sum(timeObject, currentLevel);
  return {
    gameData: {
      levelData: [
        {
          level: currentLevel,
          startTime: GAME_TIME - time[index].start,
          endTime: GAME_TIME - time[index].start + timeObject[index],
          timeLeft: seconds,
          optimalMoves: optimal[index],
          moves:
            movesObject.length && movesObject[index]
              ? pastMovesObject.length && pastMovesObject[index]
                ? movesObject[index] + pastMovesObject[index].total
                : movesObject[index]
              : 0,
          averageMoveTime:
            movesObject.length && movesObject[index] && movesObject[index] !== 0
              ? (timeObject[index] / movesObject[index]).toFixed(2)
              : 0,
          isLevelCleared: completed,
          attempts: playMoves[index],
          procInMain:
            moves.length && moves[index]
              ? moves[index].movesArray.filter(v => v === "PROCEDURE").length
              : 0,
          procCommands:
            moves.length && moves[index] ? moves[index].loopArray.length : 0,
          mainCommands:
            moves.length && moves[index] ? moves[index].movesArray.length : 0
        }
      ],
      startTime: GAME_TIME - time[0].start,
      pastMoves: pastMovesObject.map(pastMove =>
        pastMove ? pastMove : { main: 0, proc: 0, total: 0 }
      ),
      totalOptimalMoves: sum(optimal, currentLevel),
      totalMoves: totalMoves,
      totalTime: totalTime,
      totalAverageMoveTime:
        totalMoves !== 0 ? (totalTime / totalMoves).toFixed(2) : 0,
      totalLevelCompleted: completed ? currentLevel : index,
      totalAttempts: sum(playMoves, currentLevel),
      totalProcCommands:
        sum(commandList, currentLevel, 0, "proc") +
        sum(pastMovesObject, currentLevel, 0, "proc"),
      totalMainCommands:
        sum(commandList, currentLevel, 0, "main") +
        sum(pastMovesObject, currentLevel, 0, "main")
    }
  };
};

export const sendData = async data => {
  GC.sendGameDataSaveMessage(transform(data));
}

// export const sendData = async data => {
//   const gameId = storage.get.gameId();
//   const authToken = storage.get.authToken();
//   const gameplayId = storage.get.gameplayId();

//   let url = `${process.env.REACT_APP_API_ENDPOINT}/api/session/v1/${gameId}/link/${gameplayId}`;
//   try {
//     let response = await axios.post(url, transform(data), {
//       headers: {
//         Authorization: authToken
//       }
//     });
//     if (response && response.data) return true;
//     else return false;
//   } catch (error) {
//     console.log(`ERROR::${process.env.REACT_APP_GAME_NAME}::sendData::${error}`);
//     logError(error);
//     return false;
//   }
// };
